import {
  AccountResult,
  baseStringMethods,
  ConvertMethod,
  GetQueryParamMethod,
  NumberResult,
  ResultType,
  ResultTypesEnum,
  StringResult,
} from './internal';

export const urlType: ResultType = {
  name: ResultTypesEnum.URL,
  properties: {
    protocol: StringResult,
    hostname: StringResult,
    path: StringResult,
    query_string: StringResult,
    length: NumberResult,
  },
  methods: {
    get_query_param: new GetQueryParamMethod(),
    domain_to_account: new ConvertMethod(AccountResult),
    ...baseStringMethods,
  },
};
